export enum UserMissionsStatuses {
  active = 'active',
  completed = 'completed'
}

export enum MissionTypes {
  actionable = 'actionable',
  trackable = 'trackable'
}

export enum MissionEvents {
  facebookLogin = 'facebook.login',
  instagramLogin = 'instagram.login',
  createOrder = 'orders.created',
  referral = 'referrals.started',
  discountCrusher = 'discountCodes.used',
  facebook = 'public.followUsOnFacebook',
  x = 'public.followUsOnX',
  instagram = 'public.followUsOnInstagram',
  tiktok = 'public.followUsOnTiktok',
  visitPage = 'public.visitPage',
  birthday = 'birthday.reached',
}

export enum MissionActions {
  connectToInstagram = 'connectToInstagram',
  connectToFacebook = 'connectToFacebook',
  inviteAFriend = 'inviteAFriend',
  goToUrl = 'goToUrl',
  openPopupAndMarkDone = 'openPopupAndMarkDone',
  openDatePickerAndSetBirthDate = 'openDatePickerAndSetBirthDate',
}

export enum CategoriesKeys {
  purchase = 'purchase',
  basketSize = 'basketSize',
  discountCrusher = 'discountCrusher',
  referral = 'referral',
  social = 'social',
  facebook = 'facebook',
  instagram = 'instagram',
  x = 'x',
  tiktok = 'tiktok',
  birthday = 'birthday',
  specificProduct = 'specificProduct',
  specificCategory = 'specificCategory',
  visitPage = 'visitPage',
}

export enum CategoriesTypes {
  sequential = 'sequential',
  parallel = 'parallel'
}
